// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Box, CircularProgress, styled } from "@3778.care/goban";
import PropTypes from "prop-types";

const StyledBox = styled(Box)(({ theme: { spacing } }) => ({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "center",
  padding: spacing(2),
  width: "100%",
  zIndex: 100,
}));

const DarkStyledBox = styled(StyledBox)(() => ({
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  left: 0,
  position: "absolute",
  top: 0,
}));

const WhiteCircularProgress = styled(CircularProgress)(() => ({
  color: "white",
}));

export const Loading = ({ darkMode }) => {
  const LoadingComponent = () =>
    darkMode ? (
      <DarkStyledBox>
        <WhiteCircularProgress />
      </DarkStyledBox>
    ) : (
      <StyledBox>
        <CircularProgress />
      </StyledBox>
    );

  return <LoadingComponent />;
};

Loading.defaultProps = {
  darkMode: false,
};

Loading.propTypes = {
  darkMode: PropTypes.bool,
};
